var FunctionAuthProvider = function () {
  function FunctionAuthProvider() {}

  FunctionAuthProvider.TYPE = "custom-function";
  FunctionAuthProvider.DEFAULT_NAME = "custom-function";
  return FunctionAuthProvider;
}();

export default FunctionAuthProvider;